import React, { useState, useEffect } from "react";
import styles from "./orders.module.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  getDataFromRoutes, setMetaTags,
  cartToOrderProducts, repeatToOrderProducts, checkShipment,
  checkTransportedProducts, idProdutsInOrders, convertProductsInCartToShort
} from "../../utils/util_functions";
import { getCookie } from "../../utils/cookie";
import { ROUTES_CONST, USER_ROLES } from "../../utils/constants";
import { useSelector, useDispatch } from "react-redux";
import {
  getLoading, getUser, getCart, getShippings, getCustomer, getMyFirms,
  getProducts, getNewOrderProducts
} from "../../services/selectors";
import { SET_CUSTOMER } from "../../services/actions/customer_actions";
import Loader from "../../components/loader/loader";
// import ShippingsItem from "../../components/shippings_item/shippings_item";
import QuickRegisterForm from "../../components/quick-register-form/quick-register-form";
import ProductInOrder from "../../components/product_in_order/product_in_order";
import FindUser from "../../components/find_user_or_firm/find_user";
import { createOrderThunk, createOrderNoActiveThunk } from "../../services/actions/orders_actions";
import UserData from "../../components/collapsed_data_list/user_data";
import ChoiceFirm from "../../components/choice_firm/choice_firm";
import ChoiceShipping from "../../components/choice_shipping/choice_shipping";
import { getFirmsThunk } from "../../services/actions/firms_actions";
import { NEW_ORDER_SET_PRODUCTS } from "../../services/actions/new_order_actions";


const NewOrder = () => {

  const user = useSelector(getUser);
  const customer = useSelector(getCustomer);
  const firms = useSelector(getMyFirms);
  const shippings = useSelector(getShippings);
  const cart = useSelector(getCart);
  const products = useSelector(getProducts);
  const newOrderProducts = useSelector(getNewOrderProducts);

  const [stateOrder, setStateOrder] = useState(null);
  const [formValid, setFormValid] = useState(false);

  const [currShipping, setCurrShipping] = useState(null);
  const [customerFirm, setCustomerFirm] = useState(null);
  const [showFirmsList, setShowFirmsList] = useState(false);
  const [showUsersList, setShowUsersList] = useState(false);
  const [showShippingsList, setShowShippingsList] = useState(false);
  const [comment, setComment] = useState('');
  const [currFirm, setCurrFirm] = useState(null);

  const [orderShipping, setOrderShipping] = useState({
    id: null,
    active: false,
    type: null,
    name: '',
    description: '',
  });

  const isLoading = useSelector(getLoading);


  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';


  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    if (location.state?.order && Object.keys(location.state.order).length > 0
      && shippings.length > 0) {
      setCurrShipping(shippings[0]);
      const find_shipping = shippings.find(
        shipping => shipping.name === location.state.order.order_shipping_name);
      setStateOrder(location.state.order);
      dispatch({ type: SET_CUSTOMER, customer: location.state.order.customer });
      setCustomerFirm(location.state.order.firm?.id);
      setCurrFirm(location.state.order.firm);
      setComment(location.state.order.comment);
      setOrderShipping({
        ...orderShipping,
        id: find_shipping.id,
        active: true,
        type: find_shipping.type,
        name: find_shipping.name,
        description: location.state.order.order_shipping_description
      });
    }
    // eslint-disable-next-line
  }, [dispatch, shippings]);


  useEffect(() => {
    if (!('order' in location.state) || !location.state.order ||
      Object.keys(location.state.order).length === 0 ||
      location.state?.order.customer.id !== customer.id) {
      location.state.order = null;
      setCurrShipping(null);
      setOrderShipping({
        id: null,
        active: false,
        type: null,
        name: '',
        description: '',
      })
      setCurrFirm(null);
      setComment('');
      setCustomerFirm(null);
      if (customer.is_active && user.is_active) {
        dispatch({
          type: NEW_ORDER_SET_PRODUCTS,
          payload: [...checkTransportedProducts(products, newOrderProducts, customer)]
        });
      }
    }
    // eslint-disable-next-line
  }, [customer, dispatch]);

  useEffect(() => {
    if (accessToken && refreshToken && customer?.id) {
      dispatch(getFirmsThunk(accessToken, refreshToken, customer?.id));
    }
    // eslint-disable-next-line
  }, [dispatch, customer]);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, [metaTitle, metaDescription, metaKeywords, metaRobots]);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);


  function closeByEsc(e) {
    if (e.key === "Escape") {
      setShowFirmsList(false);
      setShowUsersList(false);
      setShowShippingsList(false);
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', closeByEsc);
    return (() => document.removeEventListener('keydown', closeByEsc));
    // eslint-disable-next-line
  }, []);

  const changeComment = (e) => {
    if (e.target.value.length > 255) {
      e.target.value = e.target.value.slice(0, 255);
    }
    setComment(e.target.value);
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      customer: customer.id,
      firm: customerFirm,
      order_shipping_name: orderShipping.name,
      order_shipping_description: orderShipping.description,
      productsinorder_set: idProdutsInOrders(newOrderProducts),
      comment,
      products_in_cart: convertProductsInCartToShort(cart.productsInCart)
    }
    if (!customer.is_active && !user.is_active) {
      dispatch(createOrderNoActiveThunk(navigate, data));
    } else {
      dispatch(createOrderThunk(accessToken, refreshToken, navigate, data));
    }
  }


  const handleClickMain = (e) => {
    if ((e.target.name !== 'firm') &&
      (e.target.name !== 'last_name') &&
      (e.target.name !== 'shipping_name')) {
      setShowFirmsList(false);
      setShowUsersList(false);
      setShowShippingsList(false);
    }
  }

  const handleApplyShipping = (name, description, shippings) => {
    const find_shipping = shippings.find(shipping => shipping.name === name);
    setOrderShipping({
      ...orderShipping,
      id: find_shipping.id,
      active: true,
      type: find_shipping.type,
      name: find_shipping.name,
      description,
    });
  }


  return (
    <main className='main' onClick={handleClickMain}>
      {isLoading ? <Loader /> :
        <>
          <h1 className="title">{title}</h1>
          <div className={styles.upper_container}>
            <section className={styles.section}>
              <h2 className='ml0 subtitle'>
                Покупатель
              </h2>
              {(user.role === USER_ROLES.manager || user.role === USER_ROLES.superuser) &&
                <FindUser showUsersList={showUsersList} setShowUsersList={setShowUsersList} />
              }
              {user.loggedIn ? <UserData customer={customer} /> : <QuickRegisterForm />}
            </section>
            {user.loggedIn &&
              <form onSubmit={handleSubmit} className={`form w_100_per`} id='main' noValidate>
                {customer?.is_active &&
                  <section className={styles.section}>
                    <h2 className="ml0 subtitle">Плательщик</h2>
                    <p className="fsm3 ml0">
                      Если нужной организации нет в списке, добавьте её &nbsp;
                      <span className="link"
                        onClick={() => {navigate('/profile/add_firm', { state: { from: location } });}}
                      >
                        здесь,
                      </span>
                      &nbsp; а затем вернитесь в корзину и продолжите оформление заказа.
                    </p>
                    <ChoiceFirm
                      firms={firms} setFirm={setCustomerFirm} currFirm={currFirm}
                      showFirmsList={showFirmsList} setShowFirmsList={setShowFirmsList}
                    />
                  </section>
                }
                <section className={styles.section}>
                  <h2 className="ml0 subtitle">
                    Способ получения <span style={{ color: 'red' }}>*</span>
                  </h2>
                  {(customer?.last_ship_name || customer?.pre_last_ship_name) &&
                    <>
                      <p className="fsm3">Предыдущие способы получения:</p>
                      {customer?.pre_last_ship_name && shippings?.length &&
                        checkShipment(shippings, customer.pre_last_ship_name) &&
                        <div className="lastShipContainer">
                          <div className="lastShipTextContainer">
                            <div className="lastShipName">
                              <p className="fsm3">
                                {customer.pre_last_ship_name}
                              </p>
                            </div>
                            <div className="lastShipDescription">
                              <p className="fsm3">{customer.pre_last_ship_description}</p>
                            </div>
                          </div>
                          <button
                            className="button button__small mla"
                            type="button"
                            onClick={() => handleApplyShipping(
                              customer.pre_last_ship_name, customer.pre_last_ship_description, shippings
                            )}
                          >
                            Повторить
                          </button>
                        </div>
                      }
                      {customer?.last_ship_name && shippings?.length &&
                        checkShipment(shippings, customer.last_ship_name) &&
                        <div className="lastShipContainer">
                          <div className="lastShipTextContainer">
                            <div className="lastShipName">
                              <p className="fsm3">
                                {customer.last_ship_name}
                              </p>
                            </div>
                            <div className="lastShipDescription">
                              <p className="fsm3">{customer.last_ship_description}</p>
                            </div>
                          </div>
                          <button
                            className="button button__small mla"
                            type="button"
                            onClick={() => handleApplyShipping(
                              customer.last_ship_name, customer.last_ship_description, shippings
                            )}
                          >
                            Повторить
                          </button>
                        </div>
                      }
                    </>
                  }
                  <p className="fsm3 mt20 fw500">Укажите способ получения этого заказа:</p>
                  <div className="shipContainer">
                    <ChoiceShipping
                      shippings={shippings} orderShipping={orderShipping} setOrderShipping={setOrderShipping}
                      showShippingsList={showShippingsList} setShowShippingsList={setShowShippingsList}
                      setFormValid={setFormValid}
                    />
                  </div>
                </section>
                <section className={styles.section}>
                  <h2 className="ml0 subtitle">Комментарий к заказу</h2>
                  <textarea name="comment" id="comment" className="textarea"
                    onChange={changeComment} value={comment}
                    placeholder="Текст до 256 символов"
                  />
                </section>
                <section className={styles.section}>
                  <h2 className="ml0 subtitle">Товары и цены</h2>
                  <ProductInOrder
                    productsinorder_set={newOrderProducts}
                  />
                </section>
                <button type="submit"
                  className={`button ${!formValid ? 'button_disabled' : ''}`}
                  disabled={!formValid}
                >
                  Подтвердить заказ
                </button>
              </form>
            }
          </div>
        </>
      }
    </main >
  );
}

export default NewOrder;
